/**
 * Vertical route marker running up the left edge of a band's gutter.
 *
 * Uses vertical writing-mode rather than a rotation: a rotated element keeps
 * its original horizontal layout box and would overlap the body copy, whereas
 * this one genuinely occupies a narrow vertical column.
 *
 * Decorative wayfinding, so it is hidden from assistive technology, and it
 * only appears from `xl` up where the shell's padding leaves room for it.
 */
export function RouteTab({ label }: { label: string }) {
  return (
    <p
      aria-hidden="true"
      className="pointer-events-none absolute left-5 top-1/2 z-10 hidden -translate-y-1/2 select-none whitespace-nowrap font-mono text-[9.5px] tracking-[0.3em] text-primary/40 [writing-mode:vertical-rl] xl:block"
      style={{ transform: 'translateY(-50%) rotate(180deg)' }}
    >
      GODENGINE · {label.toUpperCase()}
    </p>
  )
}
